export default __webpack_public_path__ + "static/media/sr-success-2.5b04baed.wav";